import script from "./UserPW.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPW.vue?vue&type=script&setup=true&lang=js"

import "./UserPW.vue?vue&type=style&index=0&id=1a58b084&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a58b084"]])

export default __exports__